import { render, staticRenderFns } from "./AccountActivationForm.vue?vue&type=template&id=6d6f0b50&scoped=true"
import script from "./AccountActivationForm.vue?vue&type=script&lang=js"
export * from "./AccountActivationForm.vue?vue&type=script&lang=js"
import style0 from "./AccountActivationForm.vue?vue&type=style&index=0&id=6d6f0b50&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6f0b50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d6f0b50')) {
      api.createRecord('6d6f0b50', component.options)
    } else {
      api.reload('6d6f0b50', component.options)
    }
    module.hot.accept("./AccountActivationForm.vue?vue&type=template&id=6d6f0b50&scoped=true", function () {
      api.rerender('6d6f0b50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/AccountActivationForm.vue"
export default component.exports